export const endpoint = {
  caseTableView: 'case/report/favourite',
  getExternalUrl: (externalUrlId: number) => `externalUrl/${externalUrlId}`
};

// Layout attribute names for print mode configuration
export const CASE_TABLE_VIEW_PRINT_MAX_RESULTS_ATTR = 'Table.MaxPrintResults';
export const MOBILE_BREAKPOINT = 576;
export const CASE_NO_COLUMN_NAME = 'CaseNo';
export const MAX_WIDTH_INCREASE_RATE = .1;

export const caseTableViewTranslation = {
  textDeleteCaseTitle: 5790,
  textDeleteCaseContinue: 5790,
  textDeleteCaseDescription: 7489,
  textDeleteCaseCancel: 7956,
  textEditCase: 7485,
  textOpenCase: 7437,
  textDuplicateCaseTitle: 7492,
  textOpenBowtieTitle: 7716,
  textShareCase: 8064,
  textShareCaseByEmail: 8065,
  textPrintCase: 3040,
  textEvaluationValidFrom: 6448,
  textEvaluationDescription: 6446,
  textEvaluationHideInReport: 6507,
  textAddEvaluationSubtitle: 9315,
  textAddEvaluationTitle: 9312,
  textEvaluationAddItem: 9281,
  textAddResidualEvaluation: 9313,
  textEvaluationCopyFromPreviousResidual: 9307,
  noColumnsWereSelected: 9379,
  textOpenInSurveyManager: 7122,  
  textChangeStatus: 9469,
  textChangeStatusWarningModalTitle: 8325,
  textChangeStatusWarningModalDescription: 8326,
  textChangeStatusWarningModalContinue: 8327,
  textChangeStatusWarningModalEditCase: 7485,
  textChangeStatusSuccess: 9479,
  textChangeStatusWithCaseId: 9474,
  textChangeStatusForReload: 9478,
  textChangeStatusValidationError: 9480,
  textUnlockCase: 9689,
  textLoadMoreCases: 9841,
  textMoreCasesExistPrint: 9842,
  text_more_cases_exist_print: 9842
};

export const columnMinimumWidth = {
  typeString: 250,
  typeDate: 150,
  codeTableFlat: 180,
  codeTableFlatMultiple: 180,
  codeTableHierarchical: 200,
  codeTableHierarchicalMultiple: 200,
  typeNumber: 50
};

export enum SummarySectionTag {
  Actions = 'Actions',
  Assessment = 'Assessment',
  Attachments = 'Attachments',
  Bowtie = 'Bowtie',
  Causes = 'Causes',
  CheckList = 'CheckList',
  Comments = 'Comments',
  ConnectedCases = 'ConnectedCases',
  Consequences  = 'Consequences',
  Image = 'Image',
  IntegrityStatus = 'IntegrityStatus',
  IntegrityStatusBarrierEval = 'IntegrityStatusBarrierEval',
  InvolvedDrug  = 'InvolvedDrug',
  InvolvedPersons = 'InvolvedPersons',
  ResidualRisk = 'ResidualRisk',
  Risk = 'Risk',
  Status = 'Status',
  CaseDueStatus = 'CaseDueStatus',
  Confidential= 'Confidential',
  ActionDueStatus = 'ActionDueStatus',
  ActionStatus = 'ActionStatus',
  GasTest = 'GasTest'
}
